import { render, staticRenderFns } from "./AssistKbEdit.vue?vue&type=template&id=437b7b04"
import script from "./AssistKbEdit.vue?vue&type=script&lang=js"
export * from "./AssistKbEdit.vue?vue&type=script&lang=js"
import style0 from "./AssistKbEdit.vue?vue&type=style&index=0&id=437b7b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports